<style lang="scss" scoped>
@import '@tencent/vfe-theme/theme.scss';
._pop_mask{position:fixed;z-index:9998;left:0;top:0;height:100%;width:100%;background:rgba(0,0,0,.6)}
._pop{position:fixed;z-index:9999;left:50%;top:45%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}
._pop_qq{width:80%;max-width:340PX;-webkit-box-sizing:border-box;box-sizing:border-box;}
._pop_qq .pop_wrap{padding-top:24PX;background:#fff;box-shadow:0 0 3PX rgba(0,0,0,.3);border-radius:6PX}
._pop_qq .pop_title{font-size:18PX;color:$C1;font-weight:500;line-height:normal;margin-bottom:6PX;text-align:center;word-break:break-all}
._pop_qq ._pop_icon_cancel{
  position: absolute;
  width: 40PX;
  height: 40PX;
  right: 6PX;
  top: 7PX;
  ._svg_icon_cancel{
    position: absolute;
    width: 28PX;
    height: 28PX;
    fill: #848494;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    -webkit-transform: translate3d(-50%, -50%, 0);
  }
}
._pop_qq .pop_con{padding:0 20PX;margin-bottom:25PX;border-radius:12PX}
._pop_qq .pop_con .txt{font-size:16PX;color:$C1;line-height:normal;text-align:center;word-break:break-all;}
._pop_qq .pop_con .txt .num{padding:0 3PX;color:$CVIP}
._pop_qq .v_btn_wrap{position:relative;overflow:hidden}
._pop_qq .v_btn_wrap .v_btn{color:$C1;position:relative;display:block;height:5FPX;line-height:50PX;font-size:16PX;text-align:center;text-decoration:none;}
._pop_qq .v_btn_wrap .v_btn:after{content:"";position:absolute;width:100%;top:0;left:0;right:0;border-top:1PX solid $C7;-webkit-transform:scaleY(.5);transform:scaleY(.5);-webkit-transform-origin:0 0;transform-origin:0 0}
._pop_qq .v_btn_wrap .v_btn_half{float:left;width:50%;position:relative;-webkit-box-sizing:content-box;box-sizing:content-box;font-weight: 500}
._pop_qq .v_btn_wrap .v_btn_em{color:$CVIP;font-weight: 600}
._pop_qq .v_btn_wrap .v_btn_half:before{content:"";position:absolute;height:100%;top:0;bottom:0;right:0;border-right:1PX solid $C7;-webkit-transform:scaleX(.5);transform:scaleX(.5);-webkit-transform-origin:0 0;transform-origin:0 0}
._pop_qq .v_btn_wrap .v_btn_em.v_btn_half:before{border-right:0;}
</style>

<template>
  <div>
    <div class="_pop_mask" v-if="show" @touchmove.prevent></div>
    <div class="_pop _pop_qq " v-if="show" @touchmove.prevent>
      <div class="pop_wrap">
        <div class="pop_title" v-if="title">{{title}}</div>
        <i class="_pop_icon_cancel" v-if="showClose" data-role="button" @click="close">
          <svg class="_svg_icon_cancel" viewBox="0 0 32 32">
            <path d="M17.807 16.326l4.72 4.721c0.232 0.24 0.375 0.567 0.375 0.928 0 0.739-0.599 1.337-1.337 1.337-0.362 0-0.69-0.144-0.931-0.377l0 0-4.713-4.721-4.72 4.721c-0.24 0.233-0.569 0.377-0.931 0.377-0.739 0-1.337-0.599-1.337-1.337 0-0.361 0.143-0.688 0.375-0.929l-0 0 4.72-4.721-4.72-4.721c-0.232-0.24-0.375-0.568-0.375-0.928 0-0.739 0.599-1.337 1.337-1.337 0.362 0 0.69 0.144 0.931 0.377l4.72 4.721 4.713-4.721c0.24-0.233 0.569-0.377 0.931-0.377 0.739 0 1.337 0.599 1.337 1.337 0 0.361-0.143 0.688-0.375 0.929l0-0z"></path>
          </svg>
        </i>
        <div class="pop_con">
          <p class="txt" :style="{ textAlign: align }" v-html="msg"></p>
        </div>
        <div class="v_btn_wrap cf">
          <a href="javascript:;" class="v_btn v_btn_half" v-if="type=='confirm'" @click="cancelClick">{{cancelText}}</a>
          <a href="javascript:;" class="v_btn v_btn_em" :class="{v_btn_half:type=='confirm'}"
            @click="confirmClick">{{confirmText}}</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
function extend (to, from) {
  for (var key in from) {
    to[key] = from[key]
  }
}

var alert = {
  type: 'alert', // alert 只有确定按钮 confirm 确定和取消按钮
  show: false,
  showClose: false,
  msg: '温馨提示',
  confirm: null,
  cancel: null,
  confirmText: '确定',
  cancelText: '取消',
  title: '',
  align: ''
}

export default {
  data () {
    return alert
  },
  methods: {
    close() {
      alert.show = false
    },
    confirmClick () {
      alert.show = false
      alert.confirm && alert.confirm()
    },
    cancelClick () {
      alert.show = false
      alert.cancel && alert.cancel()
    }
  },
  install (Vue) {
    /**
     * alert
     * @param options 提示内容或者配置对象
     */
    var alertFunc = Vue.prototype.alert = function (options) {
      if (typeof options === 'string') {
        options = {
          msg: options
        }
      }
      var {
        title = '', msg = '', confirm = null, confirmText = '确定', align = '', showClose = false
      } = options
      extend(alert, {
        showClose,
        title,
        msg,
        confirm,
        confirmText,
        type: 'alert',
        show: true,
        align
      })
    }

    /**
     * confirm
     * @param title
     * @param msg
     * @param confirm
     * @param cancel
     * @param v_btnConfirmText
     * @param v_btnCancelText
     */
    var confirmFunc = Vue.prototype.confirm = function ({
      title = '',
      msg = 'confirm需要至少传入msg',
      confirm = null,
      cancel = null,
      confirmText = '确定',
      cancelText = '取消',
      align = '',
      showClose = false
    } = options) {
      extend(alert, {
        showClose,
        title,
        msg,
        confirm,
        cancel,
        confirmText,
        cancelText,
        type: 'confirm',
        show: true,
        align
      })
    }

    return {
      alert: alertFunc,
      confirm: confirmFunc
    }
  }
}
</script>
